export const strings = {
  selectSomeItems: "Selecionar...",
  allItemsAreSelected: "Todos los artículos estan seleccionados.",
  selectAll: "Seleccionar todos",
  search: "Buscar",
  clearSearch: "Limpiar busqueda",
};
